module.exports = __webpack_public_path__ + "img/ang.a3b532a1.png";